import { Flex } from '@iheartjane/reefer';
import { useFormContext } from '@iheartjane/reefer-hook-form';

import type {
  SpecialTypeMap,
  SpecialTypeMapItem,
} from '@jane/business-admin/types';
import { ADDITIONAL_WEIGHTS } from '@jane/business-admin/util';
import { QUALIFIED_GROUP_TYPE_MAP } from '@jane/shared/util';

import { BulkPricing } from './special_types/BulkPricing';
import { Bundle } from './special_types/Bundle';
import { CartTotal } from './special_types/CartTotal';
import { QualifiedGroup } from './special_types/QualifiedGroup';
import { SpendingThreshold } from './special_types/SpendingThreshold';

// Dev Note: Product has no subset of critieria so its left out of this list
const getSpecialTypeData: any = ({
  specialTypeKey,
  subKey,
}: {
  hasAccess?: boolean;
  specialTypeKey: string;
  subKey: keyof SpecialTypeMapItem;
}) => {
  const specialTypeMap: SpecialTypeMap = {
    bulk_pricing: {
      name: 'ruleSettings.bulk_pricing',
      options: Object.values(ADDITIONAL_WEIGHTS).flatMap((value) => {
        if (value.id === 'each') {
          return [];
        }
        return { ...value, value: value.id };
      }),
    },
    cart_total: {
      name: 'ruleSettings.cart_total',
    },
    bundle: {
      name: 'ruleSettings.bundle',
    },
    qualified_group: {
      name: 'ruleSettings.qualified_group',
      options: Object.entries(QUALIFIED_GROUP_TYPE_MAP).map(([key, value]) => {
        return { label: value, value: key };
      }),
    },
    spending_threshold: {
      name: 'rules',
    },
  };

  return specialTypeMap[specialTypeKey as keyof typeof specialTypeMap]?.[
    subKey
  ];
};

export const SpecialTypeCriteria = () => {
  const { watch, getValues } = useFormContext();
  const specialTypeWatch = watch('special_type');
  const specialTypeValue = getValues('special_type');

  const specialType = specialTypeWatch || specialTypeValue;

  return (
    <Flex width={'100%'}>
      {specialType === 'bulk_pricing' ? (
        <BulkPricing
          name={getSpecialTypeData({
            specialTypeKey: specialType,
            subKey: 'name',
          })}
          options={getSpecialTypeData({
            specialTypeKey: specialType,
            subKey: 'options',
          })}
        />
      ) : null}
      {specialType === 'cart_total' ? (
        <CartTotal
          name={getSpecialTypeData({
            specialTypeKey: specialType,
            subKey: 'name',
          })}
        />
      ) : null}
      {specialType === 'qualified_group' ? (
        <QualifiedGroup
          name={getSpecialTypeData({
            specialTypeKey: specialType,
            subKey: 'name',
          })}
          options={getSpecialTypeData({
            specialTypeKey: specialType,
            subKey: 'options',
          })}
        />
      ) : null}
      {specialType === 'bundle' ? <Bundle /> : null}
      {specialType === 'spending_threshold' ? <SpendingThreshold /> : null}
    </Flex>
  );
};
